module.exports = __webpack_public_path__ + "static/media/cellfinate_banner_resultados.b5dc366c.jpg";